import { render, staticRenderFns } from "./NavitionTransactions.vue?vue&type=template&id=f58bf84c&"
import script from "./NavitionTransactions.vue?vue&type=script&lang=js&"
export * from "./NavitionTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports